import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AndroidIcon from "@mui/icons-material/Android";

import cityTaxiBg from "../../assets/img/city-taxi-bg.jpg";
import downloadImg from "../../assets/img/download/01.jpg";
import googlePlayBadge from "../../assets/img/google-play-badge.png";
import appStoreBadge from "../../assets/img/app-store-badge.png";

const DownloadApp = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div>
      <style jsx>{`
        .download-area {
          background-image: url(${cityTaxiBg});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-attachment: fixed;
          position: relative;
          width: 100%;
          min-height: 100vh;
          display: flex;
          align-items: center;
        }
        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          z-index: 1;
        }
        .download-wrapper {
          position: relative;
          z-index: 2;
          width: 100%;
        }
        .download-content {
          color: white;
          background: transparent !important;
        }
        .download-img {
          text-align: center;
        }
        .download-img img {
          max-width: 100%;
          height: auto;
        }

        .download-btn {
          display: flex;
          gap: 18px;
          flex-wrap: wrap;
          margin-top: 20px;
        }

        .app-btn {
          color: white;
          padding: 16px 32px;
          border-radius: 12px;
          display: inline-flex;
          align-items: center;
          gap: 14px;
          font-size: 18px;
          font-weight: 600;
          text-decoration: none;
          height: 68px;
          width: 300px;
          justify-content: center;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
          transition: all 0.3s ease;
          position: relative;
        }
        .app-btn:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
        }

        /* Google Play and App Store buttons */
        .google-play-btn,
        .app-store-btn {
          background: #098535 !important; /* Green background */
          border: 2px solid #098535;
        }
        .google-play-btn:hover,
        .app-store-btn:hover {
          background: #076b2a !important; /* Darker green on hover */
          border-color: #076b2a;
        }

        .android-outline-btn {
          background: transparent !important;
          border: 2px solid white !important;
          color: white !important;
        }
        .android-outline-btn:hover {
          background: rgba(255, 255, 255, 0.1) !important;
          border-color: #4eac3d !important;
        }
        .android-outline-btn:hover span,
        .android-outline-btn:hover svg {
          color: #4eac3d !important;
        }

        .app-btn img {
          height: 40px;
        }
        .app-btn svg {
          font-size: 40px;
          color: white;
        }

        /* Force h2 title to white with multiple selectors for maximum specificity */
        .site-title,
        h2.site-title,
        .site-heading .site-title,
        .download-content .site-heading .site-title,
        .site-title.mb-10,
        h2.site-title.mb-10 {
          color: #fede33 !important;
        }

        /* Force span inside h2 to also be white */
        .site-title span,
        h2.site-title span,
        .site-heading .site-title span,
        .download-content .site-heading .site-title span {
          color: #fede33 !important;
        }

        /* MOBILE ONLY — Text above button + reduced height */
        @media (max-width: 992px) {
          .download-btn {
            flex-direction: column;
            align-items: center;
            gap: 44px; /* generous spacing between label + button */
            width: 100%;
          }

          .app-btn {
            width: 340px;
            max-width: 90vw;
            height: 76px; /* reduced height */
            flex-direction: column;
            justify-content: center;
            padding: 14px;
          }

          /* Text directly above the button */
          .app-btn span {
            position: absolute;
            top: -40px;
            left: 50%;
            transform: translateX(-50%);
            color: white;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            line-height: 1.3;
            margin: 0;
            pointer-events: none;
            white-space: nowrap;
          }

          /* Hide the original text that was inside the button */
          .app-btn > span {
            display: none;
          }

          .app-btn img {
            height: 48px;
          }
          .app-btn svg {
            font-size: 52px;
          }
        }

        .text-white-80 {
          color: rgba(255, 255, 255, 0.9) !important;
        }
        .site-title-tagline {
          color: white !important;
        }
        .container,
        .download-wrapper,
        .row,
        .col-lg-6,
        .site-heading,
        .download-btn {
          background: transparent !important;
        }
      `}</style>

      <div className="download-area">
        <div className="overlay"></div>

        <div className="container">
          <div className="download-wrapper">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="download-content">
                  <div className="site-heading mb-4">
                    <span className="site-title-tagline justify-content-start">
                      Get Our App
                    </span>
                    <h2 className="site-title mb-10">
                      Download <span>Our CabandGo</span> App For Free
                    </h2>
                    <p className="text-white-80">
                      There are many variations of passages available but the
                      majority have suffered in some form going to use a passage
                      by injected humour.
                    </p>
                  </div>

                  <div className="download-btn">
                    <a href="#" className="app-btn google-play-btn">
                      <img src={googlePlayBadge} alt="Get it on Google Play" />
                      <span>
                        Get it on
                        <br />
                        <strong>Google Play</strong>
                      </span>
                    </a>

                    <a href="#" className="app-btn app-store-btn">
                      <img
                        src={appStoreBadge}
                        alt="Download on the App Store"
                      />
                      <span>
                        Download on
                        <br />
                        <strong>App Store</strong>
                      </span>
                    </a>

                    <Link
                      to="/android-download"
                      className="app-btn android-outline-btn"
                    >
                      <AndroidIcon />
                      <span>
                        Download
                        <br />
                        <strong>Android App</strong>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="download-img">
                  <img src={downloadImg} alt="Download Taxica App" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
